import sound from "./../../assets/sounds/pop-up-off.mp3";

import { useCallback, useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useSound from "use-sound";

import { setDelivaryOrders, setFromLoginPage } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";

const HOT_ORDERS_SOUNDED = "hot-orders-sounded";

const usePingOrders = (setDelivaryOrdersStatus) => {
  const [soundVolume, setSoundValue] = useState(1);
  const { dispatch, state, businessRepository } = useStore();
  const { settings, business, fromLoginPage } = state;

  const [play] = useSound(sound, {
    volume: soundVolume,
    interrupt: true,
  });

  const timeoutRef = useRef();
  const loadOrdersRef = useRef();
  const notifyRef = useRef();
  const allowSoundRef = useRef();

  const navigate = useNavigate();

  const allowSound = useCallback(
    (accounts, usedAccounts) => {
      if (accounts.length > 0 && usedAccounts.length === 0) return true;

      const difference = accounts.filter((e) => !usedAccounts.includes(e));

      return difference.length > 0 && settings?.soundEnabled;
    },
    [settings?.soundEnabled]
  );

  // Keep allowSoundRef up to date
  allowSoundRef.current = allowSound;

  const notify = useCallback(
    (data) => {
      if (data?.list) {
        const newOrders = data.list.map((a) => a.id);

        console.log({ newOrders });

        if (newOrders.length === 0) {
          console.log("not notify");

          setDelivaryOrdersStatus(false);

          sessionStorage.removeItem(HOT_ORDERS_SOUNDED);
        } else {
          const hots = sessionStorage.getItem(HOT_ORDERS_SOUNDED);

          let soundedOrders = [];
          if (hots) {
            soundedOrders = JSON.parse(hots);
          }

          // Use the ref instead of allowSound directly
          if (
            newOrders &&
            allowSoundRef.current &&
            allowSoundRef.current(newOrders, soundedOrders)
          ) {
            setSoundValue(0.5);

            play();

            console.log("sound...");

            sessionStorage.setItem(
              HOT_ORDERS_SOUNDED,
              JSON.stringify(newOrders)
            );

            setDelivaryOrdersStatus(true);
          }
        }
      }
    },
    [play, setDelivaryOrdersStatus]
  );

  // Keep notifyRef up to date
  notifyRef.current = notify;

  const loadOrders = useCallback(async () => {
    if (!business) return;
    console.log("load orders");

    const resp = await businessRepository.getOrders(business.business_id, { skipLoader: true });

    const data = resp?.data?.data;

    dispatch(setDelivaryOrders(data));

    // Use the ref instead of notify directly
    if (notifyRef.current) {
      notifyRef.current(data);
    }

    return data;
  }, [business, dispatch, businessRepository, notify]);

  // Keep loadOrdersRef up to date
  loadOrdersRef.current = loadOrders;

  const calcPingInterval = () => {
    const now = new Date();
    const currentHour = now.getHours(); // Get the current hour (0-23 format)

    const k = currentHour >= 0 && currentHour < 7 ? 6 : 1;

    return (settings?.pingPeriodMiliseconds || 0) * k;
  };

  useEffect(() => {
    if (timeoutRef.current) {
      clearInterval(timeoutRef.current);
    }

    if (business?.sites?.length) {
      if (
        business.sites.filter(
          (a) =>
            a.id === 3 &&
            (a.primaryTags[0]?.IsMishlohimPayme ||
              a.primaryTags[0]?.IsAcceptOnlineOrders)
        ).length
      ) {
        // Call the latest version via ref
        if (loadOrdersRef.current) {
          loadOrdersRef.current();
        }

        if (settings && settings.pingPeriodMiliseconds > 0) {
          const interval = calcPingInterval();

          // Use a wrapper that calls the latest version from ref
          timeoutRef.current = setInterval(() => {
            if (loadOrdersRef.current) {
              loadOrdersRef.current();
            }
          }, interval);
        }


                if (fromLoginPage) {

                    //navigate("/order-confirmation");

          dispatch(setFromLoginPage(false));
        }
      } else {
        dispatch(setDelivaryOrders(null));
      }
    }

    return () => {
      sessionStorage.removeItem(HOT_ORDERS_SOUNDED);

      if (timeoutRef.current) clearInterval(timeoutRef.current);

    };
  }, [
    business?.business_id,
    settings?.pingPeriodMiliseconds,
    fromLoginPage,
    navigate,
    dispatch,
  ]);

  // SSE prototype do not remove
  //
  // useEffect(() => {
  //    const eventSource = new EventSource("http://manager-api-dev.zapgroup.co.il/orders?x=1", {
  //        withCredentials: true,
  //        headers: {
  //            Authorization: `Bearer ${"123123"}`,
  //        },
  //    });

  //    eventSource.onmessage = (event) => {

  //        console.log('Message from server:', event.data);

  //        //setMessages((prevMessages) => [...prevMessages, event.data]);
  //    };

  //    eventSource.onerror = () => {
  //        console.error("EventSource failed.");
  //        eventSource.close();
  //    };

  //    return () => {
  //        eventSource.close();
  //    };
  //}, []);

  return timeoutRef;
};
export default usePingOrders;
